import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "@/lib/assets";
import { MarkdownLite } from "@/components/common/MarkdownLite";
import { MessageAttachments } from "@/components/common/MessageAttachments";
import { TicketOffer } from "@/components/customer/tickets/TicketOffer";
import { SolvedPrompt } from "@/components/customer/tickets/SolvedPrompt";

export function MessageBubble({ msg, isLast, onTicketLodged, onRated }) {
  const isUser = msg.role === "user";

  if (isUser) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
        className="flex justify-end"
        data-testid="message-user"
      >
        <div className="max-w-[85%] sm:max-w-[75%]">
          {msg.image && (
            <img src={msg.image} alt="upload" className="rounded-2xl mb-2 max-h-56 border border-[#73bf44]/40 ml-auto" />
          )}
          <div className="bg-[#73bf44] text-[#050505] rounded-2xl rounded-tr-sm px-4 sm:px-5 py-2.5 sm:py-3 font-medium whitespace-pre-wrap">
            {msg.content}
          </div>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="flex gap-3 items-start"
      data-testid="message-assistant"
    >
      <div className="w-9 h-9 rounded-full border border-neutral-700 overflow-hidden shrink-0 mt-1">
        <img src={ASSETS.nick} alt="Nick" className="w-full h-full object-cover" />
      </div>
      <div className="max-w-[88%]">
        <div className="bg-[#121212] border border-neutral-800 rounded-2xl rounded-tl-sm px-4 sm:px-5 py-2.5 sm:py-3 text-neutral-200 shadow-sm">
          {msg.content ? <MarkdownLite text={msg.content} /> : (
            <div className="flex items-center gap-1.5 py-1" data-testid="typing-indicator">
              <span className="w-2 h-2 rounded-full bg-neutral-500 typing-dot" style={{ animationDelay: "0s" }} />
              <span className="w-2 h-2 rounded-full bg-neutral-500 typing-dot" style={{ animationDelay: "0.2s" }} />
              <span className="w-2 h-2 rounded-full bg-neutral-500 typing-dot" style={{ animationDelay: "0.4s" }} />
              {msg.status && (
                <span className="ml-2 text-sm text-sky-300 animate-pulse" data-testid="typing-status">{msg.status}</span>
              )}
            </div>
          )}
        </div>

        {msg.content && <MessageAttachments sources={msg.sources} confidence={msg.confidence} />}
        {msg.content && isLast && (msg.rateable || msg.customer_feedback) && <SolvedPrompt msg={msg} onRated={onRated} />}
        {msg.content && (msg.offer_ticket || msg.ticket_ref) && <TicketOffer msg={msg} isLast={isLast} onLodged={onTicketLodged} />}
      </div>
    </motion.div>
  );
}
